if (!customElements.get('collection-archive')) {
  class CollectionArchive extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Group products by their archive year
      const allProducts = this.querySelectorAll('card-product');
      for (const product of allProducts) {
        const archiveYear = product.getAttribute('data-archive-year');

        if (!archiveYear) continue;

        const archiveGrid = this.querySelector(
          `.collection__grid[data-archive-year="${archiveYear}"]`,
        );
        archiveGrid?.appendChild(product);
      }

      // Remove empty archive grids
      for (const grid of this.querySelectorAll('.collection__grid')) {
        if (grid.children.length === 0) {
          grid.previousElementSibling.remove(); // Remove the heading
          grid.remove();
        }
      }

      // Remove borders of the products on the last row (4 products per row) per grid
      for (const grid of this.querySelectorAll('.collection__grid')) {
        const products = grid.querySelectorAll('card-product');
        const productsCount = products.length;
        const remainder = productsCount % 4 || 4; // If remainder is 0, set it to 4

        const startIndex = productsCount - remainder;
        for (let i = startIndex; i < productsCount; i++) {
          products[i].classList.add('card-product--no-bottom-border');
        }
      }

      // Show the archive container after organizing the products to prevent Flash of Unstyled Content
      setTimeout(() => {
        this.style.visibility = 'visible';
        this.style.opacity = '1';
      }, 200);
    }
  }
  customElements.define('collection-archive', CollectionArchive);
}
